import React from "react";
import { Box } from "@sproutsocial/seeds-react-box";
import { Text } from "@sproutsocial/seeds-react-text";
import { type TypeHeadingLevel } from "./ContentHeaderTypes";

interface TypeTitleAreaProps {
  title: string;
  subtitle?: string;
  headingLevel?: TypeHeadingLevel;
  subtitleAs?: "h2" | "h3" | "h4" | "h5" | "p";
  leftSlot?: React.ReactNode;
  rightSlot?: React.ReactNode;
  rightTitleElement?: React.ReactNode;
}

export const TitleArea = ({
  title,
  subtitle,
  headingLevel = "h4",
  subtitleAs,
  leftSlot,
  rightSlot,
  rightTitleElement,
}: TypeTitleAreaProps) => {
  const heading = <Text.Headline as={headingLevel}>{title}</Text.Headline>;

  return (
    <Box display="flex" alignItems="center" flex={1} width="100%" minWidth={0}>
      {leftSlot}
      <Box flex={1} minWidth={0}>
        {rightTitleElement ? (
          // Keep the element on the title's own line so it tracks the title
          // text instead of being pushed to the edge of the title area.
          <Box display="flex" alignItems="center" gap={300}>
            {heading}
            {rightTitleElement}
          </Box>
        ) : (
          heading
        )}
        {subtitle && <Text.Byline as={subtitleAs}>{subtitle}</Text.Byline>}
      </Box>
      {rightSlot}
    </Box>
  );
};
